export default __webpack_public_path__ + "static/media/Straps of the Grand Monarch.04c46b6f.jpg";